/**
 * @Author:
 * @Description:
 * @DateTime: Created in 17:28 2020/10/16
 */

import * as Vue from 'vue-tsx-support';
import { Component } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import _ from 'lodash';
import { createBEM, createNamespace } from 'src/util/bem';
import './dataComplete.less';
import StationSider from 'src/pages/stationDetail/component/stationSider';
import Bus, { Events } from 'src/util/bus';
import { StationListDOI } from 'src/pages/stationList/api/stationListApi';
import MenuBtn from 'src/pages/layout/components/menuBtn';
import alertAuditLogModal from './completeLogModal';
import DataAuditApi from './api/completLogApi';
import { DateTimeUtil } from 'src/util/dateTimeUtil';
import RouteUtils from 'src/util/routeUtils';
import { CommonUtil } from 'src/util/commonUtil';
import Button from 'src/types/iview/Button';
import DatePicker from 'src/types/iview/DatePicker';
let bem = createBEM('data-complete');

@Component({ name: 'data-manage-data-complete' })
export default class DataComplete extends Vue.Component<any> {
    date = new Date();
    mn: string = '';
    id: number = -1;
    name: string = '';
    statusMap = {};
    timeout;
    async search() {
        if(!this.mn) {
            return
        }
        let { code, data } = await DataAuditApi.searchComplete({
            mn: this.mn,
            device_id: this.id,
            start_time: DateTimeUtil.getSecondFromIviewDate((this.$refs.calendar as any).date, 'monthStart') as number,
            end_time: DateTimeUtil.getSecondFromIviewDate((this.$refs.calendar as any).date, 'monthEnd') as number,
        });
        if (code === 0) {
            let map: object = {};
            data.forEach(i => {
                map[i.data_time] = i.upload_rate;
            });
            this.statusMap = map;
        }
    }
    created() {
        Bus.$on(Events.StationChange, this.stationChange);
    }
    stationChange(data: StationListDOI.RowDataI) {
        this.mn = data.mn;
        this.name = data.name;
        this.id = data.id;
        this.search();
    }
    activated() {
        this.search();
    }
    mounted() {
        this.mn = this.$route.query.mn;
        this.name = this.$route.query.name;
        this.id = +this.$route.query.id;
        this.search();
    }
    beforeDestroy() {
        Bus.$off(Events.StationChange, this.stationChange);
        this.timeout = null;
    }
    dateChange() {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => this.search(), 500);
    }
    render(h) {
        let t = this;
        return (
            <div class={bem()}>
                <MenuBtn class={createNamespace('mb10')}></MenuBtn>
                <div class={bem('content')}>
                    <div class={createNamespace('mb10')} style="text-align: right">
                        <DatePicker
                            on-on-change={this.search.bind(this)}
                            clearable={false}
                            v-model={this.date}
                            type="month"
                            style="width:200px;display: inline-block!important;text-align: initial;"
                        />
                        <Button class={createNamespace('ml20 mr10')} type="primary" onClick={() => alertAuditLogModal(this.mn, this.name)}>
                            补遗日志
                        </Button>
                    </div>
                    <div class={bem('calendar')}>
                        <el-calendar
                            ref="calendar"
                            style="width:100%"
                            v-model={this.date}
                            on-date-change={this.search.bind(this)}
                            scopedSlots={{
                                dateCell: function(h, { date, data }) {
                                    return (
                                        <div
                                            class={bem('calender-day')}
                                            on-click={() => {
                                                if (t.statusMap[data.day] !== 100) {
                                                    RouteUtils.goTo('/' + t.$route.params.type + '/dataManage/dataComplete/handle', {
                                                        mn: t.mn,
                                                        name: t.name,
                                                        date: +date,
                                                        rate: (t.statusMap[data.day]||0) + '%',
                                                        productId: t.$route.query.productId,
                                                        cn: t.$route.query.cn,
                                                    });
                                                }
                                            }}
                                        >
                                            <div v-if={data.type === 'current-month'}>
                                                <div class={bem('date')}>
                                                    {date.getDate()}
                                                    <span class={bem('chinese-date')}>
                                                        {DateTimeUtil.getChineseDate(date)
                                                            .split('月')
                                                            .pop()}
                                                    </span>
                                                </div>
                                                <span class={bem('status')} v-if={CommonUtil.isFieldEmpty(t.statusMap[data.day])}>
                                                    无数据
                                                </span>
                                                <span v-else class={bem('status', ['data'])}>
                                                    {t.statusMap[data.day] + '%'}
                                                </span>
                                            </div>
                                        </div>
                                    );
                                },
                            }}
                        >
                            <div slot="dateCell" />
                        </el-calendar>
                    </div>
                </div>
            </div>
        );
    }
}
